import styled from 'styled-components';
import { FeatureFlags } from '$/featureFlags';

export const AuthContentContainer = styled.div<{ fullHeight?: boolean }>`
  padding: ${FeatureFlags.NewLogin ? '40px' : '0'};
`;
